import auth from "auth/auth";
import { Permissions } from "modules/layout/permissions";

// There is no single "Authorization" permission group in permissions.js - Authorization access is
// represented as the union of the per-service File.* permissions. This helper treats a user as having
// general Authorization Read/Edit access if they have that action on at least one File.* service.
export function hasAnyFilePermission(action) {
    return Object.values(Permissions.File).some(category => Boolean(category[action]) && hasPermission(category[action]));
}

export function canSetPendingAuthCounselor() {
    return [Permissions.File.Pending.Submit, Permissions.File.Pending.Edit, Permissions.File.Pending.Approve].some(hasPermission);
}


// const STORAGE_KEY = "userPermissions";

// let userPermissions = new Set();

// /**
//  * Initialize permissions from the Entra access token.
//  *
//  * Call this after acquiring the access token from MSAL.
//  */
// export function setPermissionsFromToken(claims) {
//     const permissions = claims?.roles ?? [];

//     userPermissions = new Set(permissions);

//     localStorage.setItem(
//         STORAGE_KEY,
//         JSON.stringify(permissions)
//     );
// }

// /**
//  * Load previously cached permissions from localStorage.
//  *
//  * Useful when the application starts before a fresh
//  * access token has been acquired.
//  */
// export function loadPermissions() {
//     try {
//         const stored = localStorage.getItem(STORAGE_KEY);

//         if (!stored) {
//             userPermissions = new Set();
//             return;
//         }

//         const permissions = JSON.parse(stored);

//         userPermissions = new Set(
//             Array.isArray(permissions) ? permissions : []
//         );
//     } catch {
//         userPermissions = new Set();
//     }
// }

// /**
//  * Clear permissions when the user signs out.
//  */
// export function clearPermissions() {
//     userPermissions = new Set();
//     localStorage.removeItem(STORAGE_KEY);
// }

// /**
//  * Determine whether the user has a permission.
//  *
//  * Supports:
//  *
//  *   Exact permission
//  *   Service-level FullAccess
//  *   Module-level FullAccess
//  */
// let permissionSet = new Set();

// export function setPermissions(permissions) {
//     permissionSet = new Set(permissions || []);
// } 

const READ_IMPLYING_ACTIONS = ["Edit", "Submit", "Approve", "Import", "Post", "PostDetail"];

// A scope grants an action when the role matches exactly, when the scope has FullAccess,
// or - for Read - when the user holds any write-level action on that same scope.
function scopeGrantsAction(scope, action) {
    if (auth.userHasRole(`${scope}.${action}`)) {
        return true;
    }

    if (auth.userHasRole(`${scope}.FullAccess`)) {
        return true;
    }

    return (
        action === "Read" &&
        READ_IMPLYING_ACTIONS.some(implyingAction => auth.userHasRole(`${scope}.${implyingAction}`))
    );
}

export function hasPermission(requiredPermission) {
    if (!requiredPermission) {
        return true;
    }

    const parts = requiredPermission.split(".");
    const action = parts[parts.length - 1];
    const scopes = parts.slice(0, -1);

    // Application-wide roles (Application.FullAccess / Application.Read) satisfy everything they cover.
    if (scopeGrantsAction("Application", action)) {
        return true;
    }

    // Walk from the most specific scope up to the umbrella scope, so a two-part role such as
    // "Client.Read", "Client.Edit" or "Client.FullAccess" also grants that action on every child scope.
    for (let i = scopes.length; i >= 1; i--) {
        if (scopeGrantsAction(scopes.slice(0, i).join("."), action)) {
            return true;
        }
    }

    return false;
}
// /**
//  * Check whether the user has at least one
//  * of the specified permissions.
//  */
// export function hasAnyPermission(...permissions) {
//     return permissions.some(permission =>
//         hasPermission(permission)
//     );
// }

// /**
//  * Check whether the user has every
//  * specified permission.
//  */
// export function hasAllPermissions(...permissions) {
//     return permissions.every(permission =>
//         hasPermission(permission)
//     );
// }

// /**
//  * Get the currently loaded permissions.
//  *
//  * Primarily useful for debugging or displaying
//  * permission information.
//  */
// export function getPermissions() {
//     return Array.from(userPermissions);
// }
